import React from 'react';
import NumberFormat from 'react-number-format';

export default class CurrencyConversionInput extends React.Component {

    rejectValue(values) {
        return values.floatValue !== 0;
    }

    onChange(e) {
        const event = { ...e };
        event.target.value = event.target.value.replace(/[^0-9\.]/g, '');
        this.props.onChange(event);
    }

    render() {
        return <NumberFormat {...this.props} thousandSeparator={true} decimalScale={2}
                          onChange={this.onChange.bind(this)} isAllowed={this.rejectValue.bind(this)} />
    }
}


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/paymentSettings/CurrencyConversionInput.jsx